$(document).ready(async function () {
    let hasVatRateInputField = false;
    let hasAmountExclField = false;
    await initFileManager();

    // Initiate the file manager.
    async function initFileManager() {
        // Check if the vat-rate input exists.
        if ($("input[name='vat']").length > 0) {
            hasVatRateInputField = true;
        }

        if ($("input[name='amount_excl']").length > 0) {
            hasAmountExclField = true;
        }

        if ($('textarea[name="remarks"]').length > 0) {
            $('textarea[name="remarks"]').each(function () {
                // if remarks field has more than one line, add icon to right side of field
                if ($(this)[0].scrollHeight >  ($(this).innerHeight() + 20) || $(this).val().split("\n").length > 1) {
                    $(this).after('<i class="fas fa-bars primary-color" style="position: absolute; right: 25px; bottom: 20px;"></i>');
                }
            });
        }
    }

    $('.dropdown-toggle').on('click', function () {
        const dataId = $(this).data('id');
        if (dataId !== undefined && dataId !== null && dataId === 'file-select-question-field') {
            let element = $('.file-question-select');
            // Find class .dropdown-menu
            let dropdownHeight = 100;
            // For each number of files we add 30px to the height.
            dropdownHeight = dropdownHeight + ($('#filemanager').data('file-count') * 40);
            // Max default height is 480px, if the height is higher than 480px we set the height to 480px.
            if (dropdownHeight > 480) {
                dropdownHeight = 480;
            }
            // Set the height of the dropdown menu.
            element.find(".dropdown-menu").css("max-height", dropdownHeight + "px");
            element.find(".dropdown-menu").css("min-height", dropdownHeight + "px");
            element.find(".dropdown-menu").css("max-width", "560px");
            element.find(".dropdown-menu").css("min-width", "560px");
        }
    });

    // Question selector for files in an questionnaire.
    $(".file-question-select").on("change", function (e) {
        let file_id = $(this).parents("tr").data('file_id');
        let dossier_id = $(this).parents("tr").data('dossier_id');
        let folder_id = $(this).parents("tr").data('folder_id');

        // Can occur when certain events collide
        if (this.value === undefined) {
            return;
        }
        // Save the question field.
        storeFileQuestionField(dossier_id, folder_id, file_id, this.value);
    });

    $(".calculate-vat-btn").on("click", function () {
        let amountInput = $(this).closest("tr").find("input[name='amount']");
        let amountExclInput = $(this).closest("tr").find("input[name='amount_excl']");

        calculateVat(amountInput, amountExclInput);
    });

    $("input[name='amount'],input[name='vat'],input[name='amount_excl']").on({
        blur: function () {
            let dossierId = $(this).parents('tr').data('dossier_id');
            let fileId = $(this).parents('tr').data('file_id');
            let result = formatEUCurrency($(this));

            if (!(result === 'NaN')) {
                saveField(dossierId, fileId, $(this).attr('name'), $(this).val());
                $(this)[0].style.backgroundColor = "";
            } else {
                $(this)[0].style.backgroundColor = "#FFCCCB";
            }
        }
    });

    function calculateVat(number, numberExcl) {
        if (number.attr("name") === 'vat') {
            return;
        }

        // Get the vat rate input.
        if (hasVatRateInputField) {
            const vatRate = number.parents('tr').find('input[name="vat"]')
            const parsedFloat = Number.parseFloat(number.val().replace('.', '').replace(',', '.'));
            const vatRateValue = (parsedFloat * (21 / 121));
            const currencyVal = new Intl.NumberFormat('nl-NL', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(vatRateValue);
            vatRate.val(currencyVal);
            vatRate.trigger('blur');

            // if amount_excl is empty
            if (parsedFloat !== 0 && (numberExcl.val() === '' || numberExcl.val() === 'NaN')) {
                // calc number wihout vat
                const numberExclValue = parsedFloat - vatRateValue;
                const currencyVal = new Intl.NumberFormat('nl-NL', {
                    style: 'decimal',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(numberExclValue);

                numberExcl.val(currencyVal);
                numberExcl.trigger('blur');
            }

        }
    }

    function dotCount(number) {
        const numberAsString = number.toString();
        if (numberAsString.includes('.')) {
            return numberAsString.split('.')[1].length;
        }
        return 0;
    }

    function formatEUCurrency(input) {
        let input_val = input.val();
        let start_char = input_val.charAt(0);

        // don't validate empty input
        if (input_val === "") {
            return;
        }

        if (dotCount(input_val) > 2) {
            input_val = input_val.replace('.', "");
        }

        if (dotCount(input_val) <= 2) {
            input_val = input_val.replace('.', ",");
        }

        input_val = input_val.replace(',', ".");


        let currencyVal = new Intl.NumberFormat('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(input_val);

        // send updated string to input
        if (start_char === '-') {
            currencyVal = '-' + input_val;
        }

        if (currencyVal !== 'NaN') {
            input.val(currencyVal);
        }

        return currencyVal;
    }
    // End currency


    let scrollPos = sessionStorage.getItem('scrollpos');
    if (scrollPos) {
        document.getElementById("content").scrollTo(0, scrollPos);
        sessionStorage.removeItem('scrollpos');
    }
    $(document).on('nc.sidePanel.hide', function (e, result) {
        let scrollPosition = document.getElementById("content").scrollTop;
        sessionStorage.setItem('scrollpos', scrollPosition);
        location.reload();
    });

    $('.input-textarea').focus(function () {
        $(this).attr('data-height', $(this).height());
        $(this).addClass('input-textarea-open');
        $(this).animate({height: 100}, 'slow');
        $(this).removeClass('input-textarea-closed');
    }).blur(function (e) {
        $(this).animate({height: $(this).attr('data-height')});
        $(this).addClass('input-textarea-closed');
        $(this).removeClass('input-textarea-open');
    });

    $('textarea[name="remarks"],input[name="payed_at"],input[name="number"],input[name="batch"],input[name="remarks"],select[name="costcenter"],select[name="ledger"],input[name="invoiced_at"],input[name="invoice_period"],input[name="invoice_number"]').change(function () {
        // only remarks field
        if ($(this).attr('name') === 'remarks') {
            // if textarea has more than one line, add icon to right side of field
            if ($(this)[0].scrollHeight >  ($(this).innerHeight() + 20) || $(this).val().split("\n").length > 1) {
                $(this).after('<i class="fas fa-bars primary-color" style="position: absolute; right: 25px; bottom: 20px;"></i>');
            } else {
                $(this).next().remove();
            }
        }

        if ($(this).attr('name') === 'invoice_period') {
            let invoicePeriod = $(this).val();
            invoicePeriod = invoicePeriod.replace(/\D/g, '');

            if (invoicePeriod.length > 4) {
                invoicePeriod = invoicePeriod.substring(0, 4);
            }

            if (invoicePeriod.length === 4) {
                invoicePeriod = invoicePeriod.substring(0, 2) + '-' + invoicePeriod.substring(2);
            }

            if (invoicePeriod.includes('-') && invoicePeriod.endsWith('-')) {
                invoicePeriod = invoicePeriod.slice(0, -1);
            }

            if (invoicePeriod === '--') {
                invoicePeriod = '';
            }

            $(this).val(invoicePeriod);
        }

        // when I select a invoice date, I want to update the invoice period automatically if it is empty
        if ($(this).attr('name') === 'invoiced_at') {
            if ($(this).val() === '' || $(this).val() === null) {
                if (!$(this).hasClass('color-transparent')) {
                    $(this).addClass('color-transparent');
                }

                $(this).val(null);
            } else {
                if ($(this).hasClass('color-transparent')) {
                    $(this).removeClass('color-transparent');
                }
            }


            let invoicePeriod = $(this).parents('tr').find('input[name="invoice_period"]').val();
            if (invoicePeriod === '' || invoicePeriod === null) {
                let date = new Date($(this).val());
                let year = date.getFullYear();
                // year should be 2 digits, the last two digits of the year
                year = year.toString().slice(-2);

                let month = date.getMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                $(this).parents('tr').find('input[name="invoice_period"]').val(year + '-' + month);
                saveField($(this).parents('tr').data('dossier_id'), $(this).parents('tr').data('file_id'), 'invoice_period', year + '-' + month);
            }

            saveField($(this).parents('tr').data('dossier_id'), $(this).parents('tr').data('file_id'), 'invoiced_at', $(this).val());
            return;
        }

        // If the inputs are payed_at or batch check if the date is valid and above 1970, if not do nothing
        // TODO: Why? Don't see the reason for this check
        if ($(this).attr('name') === 'payed_at' || $(this).attr('name') === 'batch') {
            if ($(this).val() === '' || $(this).val() === null) {
                if (!$(this).hasClass('color-transparent')) {
                    $(this).addClass('color-transparent');
                }

                $(this).val(null);
            } else {
                if ($(this).hasClass('color-transparent')) {
                    $(this).removeClass('color-transparent');
                }
            }
            let date = new Date($(this).val());
            if (date.getFullYear() < 1970) {
                return;
            }
        }

        let dossierId = $(this).parents('tr').data('dossier_id');
        let fileId = $(this).parents('tr').data('file_id');

        saveField(dossierId, fileId, $(this).attr('name'), $(this).val());
    });

    $('input[name="approved"],input[name="direct_debit"],input[name="checked"],input[name="processed"],input[name="show_exclamation"]').change(function () {
        let dossierId = $(this).parents('tr').data('dossier_id');
        let fileId = $(this).parents('tr').data('file_id');

        saveField(dossierId, fileId, $(this).attr('name'), $(this).is(':checked') == true ? 1 : 0);
    });

    function saveField(dossierId, fileId, column, value) {
        let inputElement = $('tr[data-file_id="' + fileId + '"]')
            .find('input[name="' + column + '"]').html(value);

        $.post(
            "/files/" + dossierId + "/file/" + fileId + "/store-field",
            {
                column: column,
                value: value
            }
        ).done(function (data) {
            try {
                if (data === 'Saved') {
                    inputElement.removeClass('is-invalid');
                    return;
                }
                inputElement.addClass('is-invalid');
            } catch (e) {
                console.log(e);
            }
        }).catch(function (error) {
            inputElement.addClass('is-invalid');
        });
    }

    function storeFileQuestionField(dossierId, folderId, fileId, fieldId) {
        $.post(
            "/files/" + dossierId + '/link-file-folder-field/' + folderId + '/' + fileId + '/' + fieldId
        );
    }

    // On file-exclamation hover change the icon to a green checkmark (folder icons only show a total and are not clickable)
    $('.file-exclamation[data-file-id]').hover(function () {
        $(this).removeClass('fas fa-exclamation-circle').addClass('fas fa-check-circle cursor-pointer').css('color', 'green');
    }, function () {
        $(this).removeClass('fas fa-check-circle').addClass('fas fa-exclamation-circle').css('color', 'red');
    });

    // On file-exclamation click set the show_exclamation to false
    $('.file-exclamation[data-file-id]').click(function () {
        const element = $(this);
        let fileId = element.data('file-id');
        let dossierId = element.data('dossier-id');

        axios.post("/files/" + dossierId + "/file/" + fileId + "/store-field", {
            column: 'show_exclamation',
            value: 0
        })
            .then(function (response) {
                element.tooltip('dispose').hide();
            })
            .catch(function (error) {
                // Optionally handle error
                console.error(error);
            });
    });
});

